export const TYPES = [
  { value: "DEPANNAGE", label: "Dépannage", icon: "🔧", desc: "Fuite, bouchon, panne" },
  { value: "ENTRETIEN", label: "Entretien", icon: "🔍", desc: "Chaudière, chauffe-eau" },
  { value: "URGENCE", label: "Urgence", icon: "🚨", desc: "Intervention immédiate" },
]

export const STEPS = [
  { n: 1, label: "Vos informations" },
  { n: 2, label: "Vérification" },
  { n: 3, label: "Choisir un créneau" },
]

export interface Slot {
  date: string
  label: string
  time: string
  dayKey: string
}

// Payload "Aucun créneau ne me convient" — partagé entre les deux flux locataire
// et le composant NoSlotButton. Le champ noSlot: true est ajouté à l'envoi.
export interface NoSlotRequest {
  noSlotAccessType: "RESIDENCE_DAY" | "FREE_ACCESS"
  residenceDayDate?: string
  companyName?: string
  firstName?: string
  lastName?: string
  phone: string
  email?: string
  address: string
  residenceName?: string
  bat?: string
  floor?: string
  postalCode?: string
  city?: string
  type?: string
  description?: string
  consent: boolean
  sessionToken?: string | null
}

export interface RdvFormData {
  companyName: string
  firstName: string
  lastName: string
  phone: string
  email: string
  address: string
  residenceName: string
  bat: string
  floor: string
  postalCode: string
  city: string
  accessCode: string
  type: string
  description: string
  consent: boolean
}

export type RdvFormErrors = Partial<Record<keyof RdvFormData, string>>

export const EMPTY_FORM: RdvFormData = {
  companyName: "",
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  address: "",
  residenceName: "",
  bat: "",
  floor: "",
  postalCode: "",
  city: "",
  accessCode: "",
  type: "",
  description: "",
  consent: false,
}
